import * as styled from '../styles/feature-checklist';
import { SectionHeading } from './section-heading';

type Props = {
  kicker: string;
  title: string;
  subtitle: string;
  features: LandingV2.FeatureItem[];
};

export const FeatureChecklist = ({ kicker, title, subtitle, features }: Props) => (
  <styled.Wrap>
    <SectionHeading kicker={kicker} title={title} subtitle={subtitle} />
    <styled.List>
      {features.map((feature) => (
        <styled.Row key={feature.title}>
          <styled.Check>✓</styled.Check>
          <styled.RowBody>
            <styled.RowTitle>{feature.title}</styled.RowTitle>
            <styled.RowDescription>{feature.description}</styled.RowDescription>
          </styled.RowBody>
        </styled.Row>
      ))}
    </styled.List>
  </styled.Wrap>
);
